import { createContext, useContext, useEffect, useState } from "react";
import api, { setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  const applyAuth = (data) => {
    if (data.access_token) setToken(data.access_token);
    setUser(data);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    applyAuth(data);
    try { const { data: me } = await api.get("/auth/me"); setUser(me); } catch (e) {}
    return data;
  };

  const acceptInvite = async (payload) => {
    const { data } = await api.post("/invites/accept", payload);
    applyAuth(data);
    return data;
  };

  const join = async (payload) => {
    const { data } = await api.post("/auth/join", payload);
    if (!data.pending) applyAuth(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, join, acceptInvite, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
